import { render } from "./IconCircle.vue?vue&type=template&id=ab3a49d6&scoped=true"
import script from "./IconCircle.vue?vue&type=script&lang=js"
export * from "./IconCircle.vue?vue&type=script&lang=js"

import "./IconCircle.vue?vue&type=style&index=0&id=ab3a49d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.29_vue@3.2.13_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3a49d6"]])

export default __exports__